var _circle, _line, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.25,
    cy: 10.25,
    r: 2,
    fill: "#78D2F1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.25,
    y1: 11.25,
    x2: 10.25,
    y2: 20.25,
    stroke: "#78D2F1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10.25C6.5 8.17893 8.17893 6.5 10.25 6.5C12.3211 6.5 14 8.17893 14 10.25C14 11.5858 13.3016 12.7584 12.25 13.4227V16.1732C14.7209 15.3391 16.5 13.0023 16.5 10.25C16.5 6.79822 13.7018 4 10.25 4C6.79822 4 4 6.79822 4 10.25C4 13.0023 5.77908 15.3391 8.25 16.1732L8.25 13.4227C7.19842 12.7584 6.5 11.5858 6.5 10.25Z",
    fill: "#78D2F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10.25C2.5 5.96979 5.96979 2.5 10.25 2.5C14.5302 2.5 18 5.96979 18 10.25C18 13.8386 15.5609 16.8576 12.25 17.7395L12.25 20.305C16.9535 19.3747 20.5 15.2265 20.5 10.25C20.5 4.58908 15.9109 0 10.25 0C4.58908 0 0 4.58908 0 10.25C0 15.2265 3.54652 19.3747 8.25 20.305L8.25 17.7395C4.93913 16.8576 2.5 13.8386 2.5 10.25Z",
    fill: "#78D2F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalMedia);
export default __webpack_public_path__ + "static/media/anal-media.94ec997b2839b989e26a07d2f46010ac.svg";
export { ForwardRef as ReactComponent };